enum AvailabilityErrorReason {
  None = 'None',
  Consignment = 'Consignment'
}

export default AvailabilityErrorReason;
